{
  "titles": {
    "confirm_password_reset": "Passwort zurücksetzen"
  },
  "descriptions": {
    "confirm_password_reset": "Wir haben Ihnen eine E-Mail mit weiteren Anweisungen zum Zurücksetzen Ihres Passwortes geschickt."
  },
  "buttons": {
    "confirm_password_reset": "Zurück zum Login"
  }
}
